import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { RodeoEvent } from 'model/rodeoEvent';

@Component({
    selector: 'nomination-logs',
    templateUrl: 'nomination-logs.html'
})
export class NominationLogsPage {
    logs: any[];

    constructor(navParams: NavParams, private viewController: ViewController) {
        this.logs = navParams.get('logs');

        console.log("logs: ", this.logs);
    }

    cancel() {
        this.viewController.dismiss();
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/organization/nominations/nomination-logs.ts